import { useAppScopeStore } from '@frontend/scope';
import { BNPLPanelLocationContextWrapper } from '../../../views/buy-now-pay-later';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';

export const SunbitSettingsGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard locationId={locationIds[0]}>
          <BNPLPanelLocationContextWrapper />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup includeNonPaymentLocations>
          <BNPLPanelLocationContextWrapper />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
